import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { useOverlayContext } from 'seagull';
import { ChevronRight24, IntegrationsLine24, Message, NoteTextLiner24, PlayIcon, Profile2UsersLiner24, ProposalLiner24 } from 'seagull/icons';
import { useIoContext } from '~/contexts';
import TutorialVideosModal from '../components/NavigationAndStructure/HelpMenu/TutorialVideosModal/TutorialVideosModal';
import { useIsMobileForHomePage } from './useIsMobileForHomePage';
export var ExternalLink = /*#__PURE__*/ function(ExternalLink) {
    ExternalLink["Link"] = "link";
    ExternalLink["Action"] = "action";
    return ExternalLink;
}({});
export function useHelpMenuExternalLinks() {
    let { hideExploreTutorials = false, hideAskSupport = false, hideVisitHelpCenter = false, hideJoinTheCommunity = false, hideWhatsNew = false, hideBookADemo = false, menuLocation = 'unknown', onOpenTutorialVideosInMobile = ()=>{} } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { intercomClient } = useIoContext();
    const { showModal } = useOverlayContext();
    const isMobileDevice = useIsMobileForHomePage();
    const externalLinks = useMemo(()=>{
        return compact([
            !hideExploreTutorials && {
                label: 'Explore tutorials',
                type: "action",
                suffixIcon: /*#__PURE__*/ _jsx(ChevronRight24, {}),
                onClick: ()=>{
                    if (isMobileDevice) {
                        onOpenTutorialVideosInMobile();
                    } else {
                        showModal({
                            closeOnClickOutside: true,
                            closeOnEscapeKey: true,
                            content: (param)=>{
                                let { dismissModal } = param;
                                return /*#__PURE__*/ _jsx(TutorialVideosModal, {
                                    dismissModal: dismissModal
                                });
                            }
                        });
                    }
                },
                icon: PlayIcon
            },
            !hideAskSupport && {
                label: 'Ask support',
                type: "action",
                onClick: ()=>intercomClient.showNewMessage(),
                icon: Message
            },
            !hideVisitHelpCenter && {
                type: "link",
                label: 'Visit help center',
                href: 'https://intercom.help/anchor-billing/en/',
                icon: ProposalLiner24
            },
            !hideJoinTheCommunity && {
                type: "link",
                label: 'Join the community',
                href: 'https://www.facebook.com/groups/sayanchor/',
                icon: Profile2UsersLiner24
            },
            !hideWhatsNew && {
                type: "link",
                label: "What's new",
                href: 'https://intercom.help/anchor-billing/en/collections/3297243-announcements',
                icon: IntegrationsLine24
            },
            !hideBookADemo && {
                type: "link",
                label: 'Book a demo',
                href: "https://go.sayanchor.com/website-book-a-demo?utm_channel=product&utm_source=in-app&utm_medium=".concat(menuLocation, "&utm_campaign=book_demo"),
                icon: NoteTextLiner24
            }
        ]);
    }, [
        hideExploreTutorials,
        hideAskSupport,
        hideVisitHelpCenter,
        hideJoinTheCommunity,
        hideWhatsNew,
        hideBookADemo,
        menuLocation
    ]);
    return {
        externalLinks
    };
}
